<template>
    <v-container>
        <div class="text-right mb-4">
            <v-btn
                :to="{ name: 'questionbank.search' }"
                color="primary"
                rounded
                class="mr-4"
            >
                <v-icon left>mdi-magnify</v-icon>
                Cari
            </v-btn>

            <v-btn
                @click="createDialog = true"
                color="primary"
                rounded
            >
                Buat baru
            </v-btn>
        </div>

        <prompt-dialog
            v-model="createDialog"
            @ok="create"
            title="Buat bank soal baru"
            label="Nama bank soal"
            okText="Buat"
        ></prompt-dialog>

        <v-list elevation="1">
            <v-list-item
                v-for="questionbank in questionbanks"
                :key="questionbank.id"
                :to="{
                    name: 'questionbank.detail',
                    params: { questionbank_id: questionbank.id },
                }"
            >
                <v-list-item-content>
                    <v-list-item-content>
                        {{ questionbank.title }}
                    </v-list-item-content>
                </v-list-item-content>

                <v-list-item-action>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-action>
            </v-list-item>
        </v-list>
    </v-container>
</template>

<script>
import PromptDialog from '@/components/PromptDialog'

export default {
    components: {
        PromptDialog,
    },

    data() {
        return {
            questionbanks: null,
            createDialog: false,
        }
    },

    methods: {
        create(title) {
            this.$api
                .post(
                    'questionbank',
                    {
                        title,
                    },
                    { loader: 'appbar' }
                )
                .then(() => {
                    this.getData()
                })
        },

        getData() {
            this.$api
                .get('questionbank', { loader: 'appbar' })
                .then((response) => {
                    this.questionbanks = response.data.questionbanks
                })
        },
    },

    created() {
        this.getData()
    },
}
</script>
